import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Row, Button, Table } from 'antd';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getConfigurations } from './appConfig.reducer';

export const Configurations = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();
  const configurations = useAppSelector(state => state.appConfig.entities);

  useEffect(() => {
    dispatch(getConfigurations());
  }, []);

  const columns = [
    {
      title: <Translate contentKey="configuration.appConfig.key">KEY</Translate>,
      dataIndex: 'ConfigKey',
      key: 'ConfigKey',
    },
    {
      title: <Translate contentKey="configuration.appConfig.value">VALUE</Translate>,
      dataIndex: 'ConfigValue',
      key: 'ConfigValue',
    },
    {
      title: 'OPTION',
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <div>
          <Row className="justify-content-center">
            <Button type="primary" style={{ height: 'auto', width: 'auto' }} data-cy="entityEditButton">
              <Link to={`${match.url}/${id}/edit`} id="jh-create-entity" data-cy="entityCreateButton">
                <FontAwesomeIcon icon="pencil-alt" />
                &nbsp; <Translate contentKey="configuration.edit">Edit</Translate>
              </Link>
            </Button>
            &nbsp;
          </Row>
        </div>
      ),
    },
  ];

  const data = configurations.map((config, i) => ({
    ConfigKey: config.configKey,
    ConfigValue: config.value,
    id: config.id,
  }));
  const { match } = props;

  return (
    <div>
      <h2 id="configuration-heading" data-cy="ClasseHeading">
        <Translate contentKey="configuration.title">Configuration</Translate>
      </h2>
      <div className="table-responsive">
        <Table columns={columns} dataSource={data} pagination={false} scroll={{ y: 400 }} />
      </div>
    </div>
  );
};

export default Configurations;
